/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Type_OrdinaryInputs */

const en_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinary termination`)
};

const de_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordentliche Kündigung`)
};

const fr_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résiliation ordinaire`)
};

const es_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminación ordinaria`)
};

const it_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risoluzione ordinaria`)
};

const nl_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewone opzegging`)
};

const pl_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypowiedzenie zwykłe`)
};

const fi_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tavallinen irtisanominen`)
};

const da_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almindelig opsigelse`)
};

const sv_consumer_declaration_type_ordinary = /** @type {(inputs: Consumer_Declaration_Type_OrdinaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanlig uppsägning`)
};

/**
* | output |
* | --- |
* | "Ordinary termination" |
*
* @param {Consumer_Declaration_Type_OrdinaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_type_ordinary = /** @type {((inputs?: Consumer_Declaration_Type_OrdinaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Type_OrdinaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_type_ordinary(inputs)
	if (locale === "fr") return fr_consumer_declaration_type_ordinary(inputs)
	if (locale === "es") return es_consumer_declaration_type_ordinary(inputs)
	if (locale === "it") return it_consumer_declaration_type_ordinary(inputs)
	if (locale === "nl") return nl_consumer_declaration_type_ordinary(inputs)
	if (locale === "pl") return pl_consumer_declaration_type_ordinary(inputs)
	if (locale === "fi") return fi_consumer_declaration_type_ordinary(inputs)
	if (locale === "da") return da_consumer_declaration_type_ordinary(inputs)
	if (locale === "sv") return sv_consumer_declaration_type_ordinary(inputs)
	return en_consumer_declaration_type_ordinary(inputs)
});